export default "__VITE_ASSET__CstNOpiN__"